import { getUserProfilePicture } from '@api';
import { updateUserReferences } from '../../_idMap/actions';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersByIdPictureGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			(request) =>
				updateUserReferences([
					{
						profilePictureTimestamp: Date.now(),
						userId: request.userId
					}
				])
		],
		successCombinationActionCreators: [
			(request, response) =>
				updateUserReferences([
					{
						profilePicture: response ? URL.createObjectURL(response) : undefined,
						profilePictureTimestamp: Date.now(),
						userId: request.userId
					}
				])
		]
	},
	name: 'CoreUsersByIdPicture',
	receive: true,
	request: true,
	requestHandler: getUserProfilePicture,
	yieldType: SagaYieldType.Every
});
